export interface NewsLikesRequestDto {
  onPage?: number | null;
  page?: number | null;
}
